<div class="hotline-modal">
	<button class="hotline-modal-close" type="button" (click)="close()">
		<i class="fal fa-times" aria-hidden="true"></i>
		<span class="sr-only">Fermer</span>
	</button>

	<h2 class="hotline-modal-title">
		{{ 'HEADER.HOTLINE.REQUESTHELP' | translate }}
	</h2>

	<div class="hotline-modal-primary-actions">
		<button class="hotline-cta hotline-cta--incident" type="button" (click)="openIncident()">
			<span class="hotline-cta-icon" aria-hidden="true">
				<i class="fal fa-exclamation-circle"></i>
			</span>

			<span class="hotline-cta-text">
				<span class="hotline-cta-title">{{ 'ITSM.BUTTON.INCIDENT' | translate }}</span>
				<span class="hotline-cta-subtitle">{{ 'HEADER.HOTLINE.REPORTINCIDENT' | translate }}</span>
			</span>
		</button>

		<button class="hotline-cta hotline-cta--service" type="button" (click)="openService()">
			<span class="hotline-cta-icon" aria-hidden="true">
				<i class="fal fa-plus-circle"></i>
			</span>

			<span class="hotline-cta-text">
				<span class="hotline-cta-title">{{ 'ITSM.BUTTON.SERVICEREQUEST' | translate }}</span>
				<span class="hotline-cta-subtitle">{{ 'HEADER.HOTLINE.REQUESTSERVICE' | translate }}</span>
			</span>
		</button>
	</div>
	<div class="hotline-modal-secondary">
		<p class="hotline-modal-secondary-title">
			{{ 'HEADER.HOTLINE.CONTACTUS' | translate }}
		</p>

		<div class="hotline-modal-options">
			<a class="hotline-modal-option" href="mailto:helpdesk@antemeta.fr">
				<span class="hotline-modal-icon">
					<i class="fal fa-envelope" aria-hidden="true"></i>
				</span>
				<span class="hotline-modal-text">
					<span class="hotline-modal-label">Par mail à</span>
					<span class="hotline-modal-value">helpdesk&#64;antemeta.fr</span>
				</span>
			</a>

			<a class="hotline-modal-option" href="tel:0800222424">
				<span class="hotline-modal-icon hotline-modal-icon--phone">
					<i class="fal fa-phone" aria-hidden="true"></i>
				</span>
				<span class="hotline-modal-text">
					<span class="hotline-modal-label">{{ 'HEADER.HOTLINE.CONTACTBYPHONE' | translate }}</span>
					<span class="hotline-modal-value">0 800 22 24 24</span>
				</span>
			</a>
		</div>
	</div>
</div>
